import { APIService, RequestBody } from '../api/apiService.js';
import { GetMultipleSettingsResponse } from '../interfaces/SettingService';

export class SettingService extends APIService {
  /**
   * @desc Get all settings
   * @return {Promise<* | undefined>}
   * @param query
   */
  getSettings(query?: string) {
    return this.request(`/settings${query ? `?${query}` : ''}`, 'GET');
  }

  /**
   * @desc Get multiple settings
   * @return {Promise<* | undefined>}
   * @param settingsEnums
   */
  getMultipleSettings(
    settingsEnums: string[]
  ): Promise<GetMultipleSettingsResponse> {
    return this.request(`/settings/multiple`, 'POST', settingsEnums);
  }

  /**
   * @desc Get a specific setting
   * @param type
   * @param query
   * @return {Promise<* | undefined>}
   */
  getSetting(type: string, query?: string) {
    return this.request(`/settings/${type}?${query}`, 'GET');
  }

  /**
   * @desc Update a setting
   * @param payload
   * @return {Promise<* | undefined>}
   */
  updateSetting(payload: RequestBody) {
    return this.request(`/settings/set`, 'POST', payload);
  }
}
